import { render } from "./ReassignInscription.vue?vue&type=template&id=11cc4738&scoped=true"
import script from "./ReassignInscription.vue?vue&type=script&lang=js"
export * from "./ReassignInscription.vue?vue&type=script&lang=js"

import "./ReassignInscription.vue?vue&type=style&index=0&id=11cc4738&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cc4738"]])

export default __exports__